import script from "./record-block-wrap.vue?vue&type=script&lang=ts&setup=true"
export * from "./record-block-wrap.vue?vue&type=script&lang=ts&setup=true"

import "./record-block-wrap.vue?vue&type=style&index=0&id=9045e49c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9045e49c"]])

export default __exports__